import { Td, Tr } from '@components/core-ui/Table';
import { Switch } from '@components/core-ui/form-elements/Switch';
import { usePageContext } from '@pages/Admin/AdminsListPage/providers/PageProvider';
import { useAuthContext } from '@providers/AuthProvider';
import { EditCellContent } from './styles/EditCellContent';
import { TProps } from './types/TProps';

export const InlineEditRow = ({ data }: TProps) => {
  const { me } = useAuthContext();
  const { editId, editPermission, isPermissionPending, deletingUserId } = usePageContext();

  if (data.id !== editId) {
    return null;
  }

  const isDeleting = deletingUserId === data.id;

  return (
    <Tr>
      <Td colSpan={100}>
        <EditCellContent>
          <div className="permissions-head">Permissions</div>
          <div className="permissions-list">
            <div className="permission">
              <Switch
                className="switch"
                checked={data.roles.includes('ROLE_BILLING_ADMIN')}
                disabled={isDeleting || isPermissionPending(data.id, 'ROLE_BILLING_ADMIN')}
                onChange={() =>
                  editPermission(data.id, 'ROLE_BILLING_ADMIN', !data.roles.includes('ROLE_BILLING_ADMIN'))
                }
              />
              <div className="label">Finance management</div>
            </div>

            <div className="permission">
              <Switch
                className="switch"
                checked={data.roles.includes('ROLE_ORG_ADMIN')}
                disabled={isDeleting || isPermissionPending(data.id, 'ROLE_ORG_ADMIN')}
                onChange={() => editPermission(data.id, 'ROLE_ORG_ADMIN', !data.roles.includes('ROLE_ORG_ADMIN'))}
              />
              <div className="label">Manage Organizations</div>
            </div>

            <div className="permission">
              <Switch
                className="switch"
                checked={data.roles.includes('ROLE_VS_ADMIN')}
                disabled
                onChange={() => undefined}
              />
              <div className="label">VS Admin</div>
            </div>

            <div className="permission">
              <Switch
                className="switch"
                checked={data.roles.includes('ROLE_SUPER_ADMIN')}
                disabled={isDeleting || isPermissionPending(data.id, 'ROLE_SUPER_ADMIN') || me.id === data.id}
                onChange={() => editPermission(data.id, 'ROLE_SUPER_ADMIN', !data.roles.includes('ROLE_SUPER_ADMIN'))}
              />
              <div className="label">Super Admin</div>
            </div>

            <div className="permission">
              <Switch
                className="switch"
                checked={data.roles.includes('ROLE_VS_DEV')}
                disabled={isDeleting || isPermissionPending(data.id, 'ROLE_VS_DEV') || me.id === data.id}
                onChange={() => editPermission(data.id, 'ROLE_VS_DEV', !data.roles.includes('ROLE_VS_DEV'))}
              />
              <div className="label">VS Dev</div>
            </div>
          </div>
        </EditCellContent>
      </Td>
    </Tr>
  );
};
